import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

import { CatalogPage } from '@/features/dictionary';

export const Route = createFileRoute('/app/dictionary')({
  component: DictionaryLayout,
});

function DictionaryLayout() {
  // alias vem da rota filha quando presente; null na rota base.
  // `<Outlet/>` é sempre truthy, então NÃO podemos passá-lo direto como
  // children (o empty state nunca apareceria). Passamos Outlet SÓ quando
  // há alias; sem alias, children = undefined → CatalogPage mostra empty.
  const params = useParams({ strict: false }) as { alias?: string };
  return (
    <CatalogPage activeAlias={params.alias ?? null}>
      {params.alias ? <Outlet /> : undefined}
    </CatalogPage>
  );
}
